import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[emailHoldShiftToChangeNumberFieldByTen]',
})
export class HoldShiftToChangeNumberFieldByTenDirective {
  shiftKey = false;

  @HostListener('keydown', ['$event']) onShiftDown(event: KeyboardEvent): void {
    if (event.key === 'Shift') {
      this.shiftKey = true;
      this.checkShift();
    }
  }
  @HostListener('keyup', ['$event']) onShiftUp(event: KeyboardEvent): void {
    if (event.key === 'Shift') {
      this.shiftKey = false;
      this.checkShift();
    }
  }

  constructor(private el: ElementRef) {}

  checkShift(): void {
    if (this.shiftKey) {
      this.el.nativeElement.step = 10;
    } else {
      this.el.nativeElement.step = 1;
    }
  }
}

// in the future, we could do something like this to add 10
// instead of incrimenting by 10
// https://www.bennadel.com/blog/3695-creating-an-incrementing-input-directive-inspired-by-chrome-dev-tools-in-angular-9-0-0-next-5.htm
